export type { BodyTextProps } from './BodyText'
export { BodyText } from './BodyText'
